//Reset data
export const RESET = "RIGHT_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "RIGHT_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "RIGHT_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "RIGHT_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "RIGHT_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "RIGHT_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "RIGHT_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "RIGHT_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "RIGHT_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "RIGHT_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "RIGHT_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "RIGHT_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "RIGHT_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "RIGHT_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "RIGHT_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "RIGHT_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "RIGHT_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "RIGHT_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "RIGHT_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "RIGHT_SHOW_SET_MODAL_TYPE"